import _noop from 'lodash/noop';
import 'prop-types';
import '@dbh/date-fns-prop-types';
import '@dbh/generic-types';

const loyaltyCampaignImmutablePropType=_noop;const loyaltyUserPointsImmutablePropType=_noop;const loyaltyProfileImmutablePropType=_noop;const userLoyaltyDataImmutablePropType=_noop;

export { loyaltyCampaignImmutablePropType, loyaltyProfileImmutablePropType, loyaltyUserPointsImmutablePropType, userLoyaltyDataImmutablePropType };
